import React, { useEffect, useState } from "react";
import { Avatar, useChatContext } from "stream-chat-react";
import "./channelHeaderCustom.css";

export const ChannelHeaderCustom: React.FC = () => {
	const { channel: activeChannel, client } = useChatContext();
	const [lastSeenTimestamp, setLastSeenTimestamp] = useState<Date | undefined>();

	useEffect(() => {
		if (activeChannel) {
			const members = Object.values(activeChannel.state.members).filter(({ user }) => user?.id !== client.userID);

			const { user } = members[0];
			setLastSeenTimestamp(parseLastSeen(user?.last_active)); // Assuming the last seen property is named "last_seen"
		} else {
			setLastSeenTimestamp(undefined);
		}
	}, [activeChannel]);

	const parseLastSeen = (lastSeenString: string | undefined): Date | undefined => {
		if (!lastSeenString) return undefined;

		try {
			// Assuming the last seen string is in ISO 8601 format (adjust if necessary)
			return new Date(lastSeenString);
		} catch (error) {
			console.error("Error parsing last seen string:", error);
			return undefined; // Handle parsing errors gracefully
		}
	};

	const renderLastSeen = (): string => {
		if (!lastSeenTimestamp) {
			return "Non connecté"; // Default message for offline users without last seen
		}

		const now = new Date();
		const diffInMs = now.getTime() - lastSeenTimestamp.getTime();

		const minutes = Math.round(diffInMs / (1000 * 60));
		const hours = Math.round(minutes / 60);
		const days = Math.round(hours / 24);

		if (days > 0) {
			return `hors ligne il y a ${days} jour${days > 1 ? "s" : ""}`;
		} else if (hours > 0) {
			return `Hors ligne il y a ${hours} heure${hours > 1 ? "s" : ""}`;
		} else {
			return `Hors ligne il y a ${minutes} minute${minutes > 1 ? "s" : ""}`;
		}
	};
	// const selected = channel?.id === activeChannel?.id;

	const members = activeChannel?.state?.members
		? Object.values(activeChannel?.state?.members).filter(({ user }) => user?.id !== client.userID)
		: [];

	const { user } = members[0];

	return (
		<div className="header-container">
			<Avatar imageUrl={user?.image} userName={user?.name} size="lg" />
			<div>
				<p className="profile">{user?.name}</p>
				<p className="liveIndicator">{user?.online ? "En ligne" : renderLastSeen()}</p>
			</div>
		</div>
	);
};
